import { Checkbox, FormControlLabel } from "@mui/material";

import HNSColors from "../../../../ui library/HNSColors";

export default function PaymentsCheckboxField({ checked, label, onChange }) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={(event) => onChange(event.target.checked)}
          sx={{
            color: HNSColors.neutrals[400],
            "&.Mui-checked": {
              color: HNSColors.primary[500],
            },
          }}
        />
      }
      label={label}
      sx={{
        marginLeft: 0,
        color: HNSColors.neutrals[100],
      }}
    />
  );
}
